import axios from 'axios';
import React, { useState } from 'react';

const FeedbackModal = ({ isOpenFeedbackModal, setIsOpenFeedbackModal }) => {
  const [feedback, setFeedback] = useState('');
  const [rating, setRating] = useState(5);

  const userid = localStorage.getItem("userid");

  const handleFeedbackChange = (e) => {
    setFeedback(e.target.value);
  };

  const handleRatingChange = (e) => {
    setRating(Number(e.target.value));
  };

  const closeHandler = (e) => {
    setIsOpenFeedbackModal(false); 
};

const handleSubmit = async () => {
  if (!feedback || !rating) {
      alert('All fields (Feedback, Rating, Active Status) are required');
      return;
  }

  const feedbackData = {
      userid, 
      message: feedback, 
      rating,           
      isActive:1, 
  };

  try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}feedbacks/createFeedback`,feedbackData);
      if (response.status!==201) {
          throw new Error(response.message || 'Failed to submit feedback');
      }

      // Success feedback
      alert('Feedback submitted successfully!');
      // Clear form fields
      setFeedback(''); 
      setRating(5);    
      closeHandler();  
      setIsOpenFeedbackModal(false);
  } catch (error) {
      console.error('Error submitting feedback:', error.message);
      alert('An error occurred while submitting feedback. Please try again.');
      setIsOpenFeedbackModal(false);
  }
};


  return (
    isOpenFeedbackModal && (
      <div
  className="modal fade show"
  style={{
    display: 'block',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(5px)', 
  }}
  tabIndex="-1"
  aria-labelledby="feedbackModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered modal-lg">
    <div className="modal-content">
      {/* Modal Header */}
      <div className="modal-header bg-primary text-white">
        <h5 className="modal-title" id="feedbackModalLabel">
          We Value Your Feedback
        </h5>
        <button
          type="button"
          className="btn-close btn-close-white"
          onClick={closeHandler}
          aria-label="Close"
        ></button>
      </div>

      {/* Modal Body */}
      <div className="modal-body">
        <div className="mb-4">
          <label htmlFor="feedback" className="form-label fw-semibold">
            Your Feedback
          </label>
          <textarea
            id="feedback"
            className="form-control border-primary"
            rows="5"
            placeholder="Let us know your thoughts..."
            value={feedback}
            onChange={handleFeedbackChange}
            style={{
              resize: 'none',
              borderRadius: '0.5rem',
            }}
          />
        </div>

        <div className="mb-4">
          <label htmlFor="rating" className="form-label fw-semibold">
            Rate Us
          </label>
          <select
            id="rating"
            className="form-select border-primary"
            value={rating}
            onChange={handleRatingChange}
            style={{ borderRadius: '0.5rem' }}
          >
            {[1, 2, 3, 4, 5].map((value) => (
              <option key={value} value={value}>
                {value} -{' '}
                {value === 5
                  ? 'Excellent'
                  : value === 4
                  ? 'Good'
                  : value === 3
                  ? 'Average'
                  : value === 2
                  ? 'Below Average'
                  : 'Poor'}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary w-100 fw-semibold"
          onClick={handleSubmit}
        >
          Submit Feedback
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary w-100 fw-semibold mt-2"
          onClick={closeHandler}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>

    )
  );
};

export default FeedbackModal;
